// extracted by mini-css-extract-plugin
export default {"heading":"UsersListV2_heading__csft0","sortIcon":"UsersListV2_sortIcon__jSlGb","actionButton":"UsersListV2_actionButton__LD5nK","deleteButton":"UsersListV2_deleteButton__UPWlw"};